import {
    setPhotoColorByName,
    refreshArray,
    formatTime,
    parseQueryString,
    loadJavascriptFile,
    loadJavascriptFileArray,
    checkDataValidFun,
    correctHttp,
    backValidTime,
    getDevicePlat,
    objectArraySort,
    createUUID,
    systemLang,
    compare,
    utf16toEntities,
    getHrefQuery,
    translateParam,
    getDistanceTop,
    moneyFormat,
    isIphoneX,
    toUrl,
    trim,
    toSpace,
    zwLenth,
    charactersToLength,
    getSystem,
    iosPtToPx,
    compatibleNavImg,
    getAppPageConfig

  } from './tools'

import {
  getStorage,
  setStorage,
  clearStorage,
  removeStorage,
  getSession,
  setSession,
  clearSession,
  removeSession,
  getSaveData,
  setSaveData,
  setCache,
  getCache,
  hrRouter
} from './storage'

export {
  setPhotoColorByName,
  getStorage,
  setStorage,
  clearStorage,
  removeStorage,
  getSession,
  setSession,
  clearSession,
  removeSession,
  getSaveData,
  setSaveData,
  setCache,
  getCache,
  refreshArray,
  formatTime,
  parseQueryString,
  loadJavascriptFile,
  loadJavascriptFileArray,
  checkDataValidFun,
  correctHttp,
  backValidTime,
  getDevicePlat,
  objectArraySort,
  createUUID,
  systemLang,
  compare,
  utf16toEntities,
  getHrefQuery,
  translateParam,
  getDistanceTop,
  moneyFormat,
  isIphoneX,
  toUrl,
  hrRouter,
  trim,
  toSpace,
  zwLenth,
  charactersToLength,
  getSystem,
  iosPtToPx,
  compatibleNavImg,
  getAppPageConfig
}
